import React from 'react';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';

function PrivacyPolicy() {
  return (
    <div className="App">
      <TopBar />
      <div style={{ 
        padding: '120px 24px 48px 24px',
        maxWidth: '1200px',
        margin: '0 auto'
      }}>
        <h1 style={{ color: '#004080', marginBottom: '32px' }}>Privacy Policy</h1>
        
        <div style={{ color: '#333', lineHeight: '1.6' }}>
          <section style={{ marginBottom: '32px' }}>
            <p style={{ fontSize: '16px', marginBottom: '24px' }}>
              <strong>Effective Date: September 29, 2025</strong>
            </p>
            <p style={{ marginBottom: '24px' }}>
              Connection Health Care ("we," "our," or "us") respects your privacy and is committed to protecting the personal and medical information you provide. This Privacy Policy explains how we collect, use, store, and share your information when you use our services.
            </p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>1. Information We Collect</h2>
            <p style={{ marginBottom: '16px' }}>We collect the following information from users who are adults (18+):</p>
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px' }}>
                <strong>Health Information:</strong> Details about health conditions, symptoms, and other medical data entered manually into our system.
              </p>
              <p style={{ marginBottom: '8px' }}>
                <strong>Account Information:</strong> Email address or other information used to create and manage your account.
              </p>
            </div>
            <p>We do not collect data from external devices or apps.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>2. How We Use Your Information</h2>
            <p style={{ marginBottom: '16px' }}>We use the information you provide to:</p>
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px' }}>Provide our services, including sharing your data with licensed personal service workers to support your care.</p>
              <p style={{ marginBottom: '8px' }}>Communicate with you regarding your account or services.</p>
              <p style={{ marginBottom: '8px' }}>Improve and maintain our services.</p>
            </div>
            <p>We do not sell or use your data for advertising purposes.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>3. How We Share Your Information</h2>
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px' }}>We may share your medical information with licensed personal service workers involved in providing you services.</p>
              <p style={{ marginBottom: '8px' }}>We do not share your data with any other third parties, including advertisers or analytics companies.</p>
            </div>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>4. Data Storage and Security</h2>
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px' }}>Your information is stored securely in the cloud.</p>
              <p style={{ marginBottom: '8px' }}>All data is encrypted both in transit and at rest to prevent unauthorized access.</p>
              <p style={{ marginBottom: '8px' }}>We implement administrative, technical, and physical safeguards to protect your information.</p>
            </div>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>5. Your Rights</h2>
            <p style={{ marginBottom: '16px' }}>You have the following rights regarding your data:</p>
            <div style={{ marginBottom: '16px' }}>
              <p style={{ marginBottom: '8px' }}><strong>Access:</strong> You can request a copy of the information we hold about you.</p>
              <p style={{ marginBottom: '8px' }}><strong>Deletion:</strong> You can request that we delete your data at any time.</p>
            </div>
            <p>Requests can be submitted by contacting us at info@connectionhealth.ca.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>6. Retention</h2>
            <p>We retain your information only as long as necessary to provide services or comply with legal obligations. Once your data is no longer needed, it will be securely deleted.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>7. Age Restrictions</h2>
            <p>Our services are intended for use by adults (18 years or older). We do not knowingly collect information from minors.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>8. Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time. The updated policy will be posted with a revised effective date. Your continued use of our services constitutes acceptance of the updated Privacy Policy.</p>
          </section>

          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#004080', fontSize: '24px', marginBottom: '16px' }}>9. Contact Us</h2>
            <p>If you have any questions, concerns, or requests regarding your data or this Privacy Policy, please contact us at:</p>
            <p style={{ marginTop: '8px' }}><strong>Email:</strong> info@connectionhealth.ca</p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
